export enum CustomPDFReportType {
    AGGREGATE_SECURITY_COMPARISON = 'aggregate_security_comparison',
    AGGREGATE_SECURITY_OVERVIEW = 'aggregate_security_overview',
    MULTI_SECURITY_COMPARISON = 'multi_security_comparison',
}
